import React from "react";
import ReactDOM from "react-dom";

import queryString from "query-string";

import { Alert } from "reactstrap";
import { Promise } from "ag-grid-community";

import {
  getCloudhubUserInfoFromAuth0Token,
  get,
  logOut,
} from "./context/API";
import { history } from "../../history";

import {
  getDecryptedItem,
  setEncryptedItem,
} from "./encryptedStorage";

function getValueFromObj(array, val) {
  let res = array.find((item) => item.label === val);

  if (res) {
    return res.val;
  } else {
    return 0;
  }
}

function setEnviournmentNews() {
  const URL = {
    BASE: "https://newsapi.org/v2/top-headlines",
    API_KEY: "0dc8ac7f0e564f7a98de3c56a0d9c640",
    COUNTRY: "in",
    getDefaultUrl: function (country = this.COUNTRY) {
      return this.BASE + "?apikey=" + this.API_KEY + "&country=" + country;
    },
  };

  get(URL.getDefaultUrl()).then(
    (promise) => {
      // setNews(promise.data.articles);
      console.log(promise.data.articles);
    },
    function (e) {
      console.error(e);
    }
  );
}

function limitString(string, limit) {
  return string.substring(string, limit);
}

function checkAndSetData(key, getData, setCollectionData) {
  let data = getData(key);
  if (data && data.length > 0) {
    setCollectionData(data);
    return true;
  }
  return false;
}

function alert(message, type) {
  ReactDOM.render(
    <Alert color={type || "primary"}>{message}</Alert>,
    document.getElementById("custom-alert")
  );

  setTimeout(() => {
    ReactDOM.render(<></>, document.getElementById("custom-alert"));
  }, 3000);
}

const fetchAndSetUserData = ({ token }) => {
  return getCloudhubUserInfoFromAuth0Token(token).then(
    async ({
      loginInfo: auth0LoginInfo,
      status: auth0status,
      errorMessage: auth0ErrorMessage,
    }) => {
      if (auth0status && auth0LoginInfo) {
        const userInfo = auth0LoginInfo?.userInfo;

        const userData = setUserData(userInfo);
        return userData;
      } else {
        if (auth0ErrorMessage) {
          console.error(auth0ErrorMessage);
        }
        logOut();
        return null;
      }
    },
    (err) => {
      console.error(err);
      logOut();
      return null;
    }
  );
};

/**
 * responsible for getting the user details
 */
const handleUserDetails = () => {
  const { token: tokenNew } = queryString.parse(
    window.location.search
  );

  const tokenOld = getDecryptedItem("token");

  const token = tokenNew || tokenOld;
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.getElementsByTagName("head")[0].appendChild(link);
  }

  const BASE_URL = document?.location?.origin || "";

  switch (origin) {
    case "cloudhub360":
    default:
      document.title = "askelie | Workbench";
      link.href = `${BASE_URL}/favicon.ico`;
      break;
  }

  return new Promise(async (res, rej) => {
    try {
      const isLoggedIn = getDecryptedItem("loggedIn") === "true";
      const isUserDataAvailable = getDecryptedItem("data");
      let userData = null;
      if (isUserDataAvailable) {
        userData = JSON.parse(isUserDataAvailable);
      }

      if (isLoggedIn) {
        if (isUserDataAvailable) {
          res(userData);
        } else {
          // url data mismatch
          if (!tokenNew) {
            logOut();
            res(null);
          } else if (!tokenOld) {
            logOut();
            res(null);
          } else {
            setEncryptedItem("token", tokenNew);
            const userData = await fetchAndSetUserData({ token });
            res(userData);
          }
        }
      } else {
        if (token) {
          setEncryptedItem("token", tokenNew);
          const userData = await fetchAndSetUserData({ token });
          res(userData);
        } else {
          logOut();
          res(null);
        }
      }
    } catch (e) {
      console.warn(e);
    }
  });
};

const setUserData = (userData) => {
  if (userData && userData.id) {
    setEncryptedItem("data", userData);
    setEncryptedItem("loggedIn", true);

    history.push("/");
    return userData;
  } else {
    logOut();
    return null;
  }
};

const sortAscending = (arr, key) => {
  if (arr?.length) {
    if (key) {
      return arr.slice().sort((a, b) => {
        if (a[key] < b[key]) {
          return -1;
        }
        if (a[key] > b[key]) {
          return 1;
        }
        return 0;
      });
    }
    return arr.slice().sort((a, b) => {
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    });
  }
  return arr;
};

export {
  getValueFromObj,
  setEnviournmentNews,
  limitString,
  checkAndSetData,
  alert,
  handleUserDetails,
  fetchAndSetUserData,
  sortAscending,
};
